import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from 'lodash';


import * as types from "../../../constants/actionTypes";
import * as prayerFeatureConsts from "../../../constants/prayerFeatureConstants";
import * as msgs from "../../../constants/textConstants";
import * as d from "../../../reducers/domainReducer";
import Nav from './Nav';
import Logo from '../../header/Logo';
import { Divider } from '../../ecosystem';
import { getSiteMenuItems } from './MenuItems/MyBSW.js';

/* eslint-disable react/prop-types */
/**
 * Main app menu. Expects props to contain an array of strings identifying the menu items to enable.
 */
class Menu extends React.Component {

    constructor(props) {
        super(props);

        this.toggleMainMenu = this.toggleMainMenu.bind(this);
        this.hideMainMenu = this.hideMainMenu.bind(this);

        this.patientId = null;
        this.currentPharmacyId = null;
        const membershipsAuthorizedFeatures = this.getAuthorizedFeatures();

        let initialState = {};

        if (initialState.activeSleekMenu !== "") {
            initialState = {
                ...initialState,
                showMainMenu: false
            };
        }

        this.state = {
            showMainMenu: false,
            membershipsAuthorizedFeatures: membershipsAuthorizedFeatures
        };
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.throttle);
        }
    }

    componentDidUpdate(prevProps) {
        const { currentUser, currentPharmacyUser } = this.props;
        const patientId = currentUser ? currentUser.dn : null;
        const currentPharmacyId = currentPharmacyUser ? currentPharmacyUser.pharmacyPatientId : '';
        //update.

        if (patientId && patientId !== this.patientId) {
            this.patientId = patientId;
        } else if (currentPharmacyId !== this.currentPharmacyId) {
            this.currentPharmacyId = currentPharmacyId;
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.throttle);
        }
        if (this.historyUnListen) {
            this.historyUnListen();
        }
    }

    /**
     *  @returns {object} an object only with the elements that start with hasAuthorizedFeature
     */
    getAuthorizedFeatures() {
        const af = Object.keys(window.store.getState().memberships).reduce((a, element) => {
            if (element.startsWith("hasAuthorizedFeature")) {
                a[element] = window.store.getState().memberships[element];
            }
            return a;
        }, {});
        return af;
    }

    /* Toggle Mobile Menu Open and Close */
    toggleMainMenu() {
        this.setState({
            showMainMenu: !this.state.showMainMenu
        });
    }

    /* Close Mobile Menu */
    hideMainMenu(type) {
        this.setState({
            showMainMenu: false
        });
    }

    render() {
        const {
            activeProfile,
            bundle,
            currentUser,
            currentPharmacyUser,
            epicEHRDown,
            hasMyChart,
            myChartAuthorizedEpicFeatures,
            isProxyUser,
            isMyChartInActive,
            isDashboardMenuCollapsed
        } = this.props;

        const { showMainMenu, membershipsAuthorizedFeatures } = this.state;
        const pathname = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
        const isPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
        const isMyBSWHealth = bundle === "mybswhealth" && !isPharmacy;
        const isMyChartProxyUser = isProxyUser;
        const notPharmacyProxy = isMyBSWHealth || isPharmacy && !currentPharmacyUser; // Pharmacy Only Proxy
        const isMyChartUser = notPharmacyProxy && hasMyChart;
        const isPrimaryUser = notPharmacyProxy && !isMyChartProxyUser;
        const disableMyChartMenuItems = epicEHRDown || isMyChartInActive;
        const authorizedFeaturesProps = {
            activeProfile,
            myChartAuthorizedEpicFeatures,
            membershipsAuthorizedFeatures
        };
        const menuProps = {
            authorizedFeaturesProps,
            disableMyChartMenuItems,
            isMyChartProxyUser,
            isMyChartUser,
            isPrimaryUser,
            notPharmacyProxy,
            ...this.props,
        };

        const mobileMenuOpenClass = (showMainMenu ? " menu-open" : " menu-closed");
        const collapsedMenuClass = isDashboardMenuCollapsed ? " menu-list-collapsed" : "";

        const siteMenuItems = getSiteMenuItems(menuProps, this.state);

        return (<div data-element-id="main menu container" className={"menu main-menu-container" + mobileMenuOpenClass + collapsedMenuClass}>
            <div data-element-id="menu header" className="menu-header">
                <div className="main-menu-header">

                    <div className="menu-btn" onClick={this.toggleMainMenu}>
                        <div className="hamburger">
                            <div className="hamburger-inner">
                                <span />
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    <div className="main-menu-logo">
                        <Logo />
                    </div>
                </div>
            </div>
            <div data-element-id="menu list" className={`menu-list`}>
                <Nav
                    siteMenuItems={siteMenuItems}
                    toggleMainMenu={() => { this.toggleMainMenu() }}
                    updateActiveNavTriggers={currentUser?.wprid}
                />
                <Divider
                    style={{ marginTop: '-15px' }}
                    mRight="none"
                    mTop="none"
                    mLeft="none"
                    orientation="vertical"
                    size="auto"
                />
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData,
        canAccessThrive: state.domain.ct,
        isEmployee: state.domain.ie,
        hasMyChart: state.domain.hm,
        hasHealthPlanLogin: state.memberships.hasAnySWHP,
        hasFirstCare: state.memberships.hasFC,
        hasAAL: state.memberships.hasAA,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        swhp: state.memberships.amiSWHPMembershipId, //amisys swhp id
        epicEHRDown: state.common.epicEHRDown,
        bffDashboardData: state.dashboard.bffDashboardData,
        enableCareCompanion: state.dashboard?.bffDashboardData?.data?.currentUser?.careCompanion?.isCareCompanion,//state.memberships.enableCareCompanion,
        enableHappyTogether: state.session.serverData?.enableHappyTogether,
        swhpDown: state.common.swhpDown,
        rxDown: state.common.rxDown,
        aalDown: state.common.aalDown,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",  // we'll default with rendering for mybswhealth
        isProxyUser: state.domain.ip,
        isShowAllUsers: state.dashboard.isShowAllUsers,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        currentUser: state.domain.cu,
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        healthPlanUrl: state.session.serverData.healthPlanApiUrl + '#/?t=' + encodeURIComponent(state.domain.t),
        thriveData: state.thrive.card,
        thriveDataSuccess: state.thrive.cardSuccess,
        showCustomBanner: state.domain.sb,
        currentLocation: state.common.currentLocation,
        sameDayVideoVisitScheduleEnabled: state.session.serverData.sameDayVideoVisitScheduleEnabled,
        hpIdentity: state.session.healthPlanUserProfile, // still coming from token (indirectly)? i dont think this is available in memberships
        isMemberPayer: state.domain.hpp, // still coming from token? i dont think this is available in memberships
        dentalInvoice: state.session.hasADental,
        enablePricingTransparency: isPricingTransparencyEnabled(state),
        isActiveFeature_EVisit: state.memberships.isActiveFeature_EVisit,
        isActiveFeature_AmbulatoryVideoVisit: state.memberships.isActiveFeature_AmbulatoryVideoVisit,
        isActiveFeature_SDCVideoVisit: state.memberships.isActiveFeature_SDCVideoVisit,
        hasAuthorizedFeatureSameDayVideo: state.memberships.hasAuthorizedFeatureSameDayVideo,
        hasAuthorizedFeatureMyConditions: state.memberships.hasAuthorizedFeatureMyConditions,
        isActiveFeature_InsuranceModule: state.memberships.hasAA || state.memberships.hasAnySWHP || state.memberships.hasFC || (state.memberships.hasDART && state.memberships.isActiveFeature_InsuranceModule) || (state.memberships.hasWACO && state.memberships.isActiveFeature_InsuranceModule),
        isActiveFeature_OnlineAppointmentScheduling: state.memberships.isActiveFeature_OnlineAppointmentScheduling,
        insuranceTabText: state.memberships.insuranceTabText,
        enablePrayerFeature: state.session.serverData && state.session.serverData.enablePrayerFeature,
        communitySupportBanned: state.session.userPreferences && state.session.userPreferences[prayerFeatureConsts.COMMUNITY_SUPPORT_BANNED],
        isActiveFeature_Amity: state.memberships.activeFeatures && state.memberships.activeFeatures.amity,
        enableInHomeFeature: state.session.serverData.enableInHomeFeature && (state.memberships.isActiveFeature_InHomeVaccine || (!state.domain.ip && state.memberships.isActiveFeatureAnyone_InHomeVaccine)),
        activeProfile: state.memberships.activeProfile,
        myChartAuthorizedEpicFeatures: state.session.serverData.myChartAuthorizedEpicFeatures.replace("&#xD;&#xA;", "").unescapeHTML(),
        Covid19AgeForVaccine: state.session.serverData.Covid19AgeForVaccine ? state.session.serverData.Covid19AgeForVaccine : 12,
        isMedicalAdvice: state.memberships.hasAuthorizedFeatureMedicalAdvice,
        EnableProfileDashboard: state.session.serverData && state.session.serverData.EnableProfileDashboard ? true : false,
        isMyChartInActive: state.dashboard.isMyChartInActive,
        isDashboardMenuCollapsed: state.domain.dmc,
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => {
            dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage });
        },
        clearSearch: () => {
            dispatch({ type: types.SEARCH_PROVIDER_CLEAR });
            dispatch({ type: types.SEARCH_LOCATION_CLEAR });
        },
        updateMenu: (currentLocation) => dispatch({ type: types.UPDATE_MENU, currentLocation }),
    };
};
const isPricingTransparencyEnabled = (state) => {

    let enabled = state.session.serverData.enablePricingTransparency ? state.session.serverData.enablePricingTransparency : false;
    let enablingUser = window.currentUserName === state.session.serverData.enablingPricingTranparencyUser ? true : false;
    return enabled || enablingUser;
}
const MenuHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Menu);

/* eslint-enable react/prop-types */
export default withRouter(MenuHOC);